





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IAgreementType } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'agreementType';
const ns = { namespace };

@Component
export default class AgreementTypeDetail extends BaseDetail<
  IAgreementType
> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IAgreementType>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
